import * as React from 'react';

function SvgEvents(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21.694 22.504" {...props}>
      <path
        data-name="Path 1998"
        d="M19.77 2.441h-1.874V.949A1.054 1.054 0 0016.73 0h-1.6a.934.934 0 00-1.034.949V2.44h-6.5V.949A.934.934 0 006.563 0h-1.6a1.054 1.054 0 00-1.167.949V2.44H2.062A2.006 2.006 0 00-.004 4.39V20.2a2.206 2.206 0 002.061 2.3h17.57a2.206 2.206 0 002.069-2.3V4.528a2.006 2.006 0 00-1.926-2.087zm-4.639-1.356h1.681v2.982h-1.681zm-10.168 0h1.545v2.982H4.963zM20.608 20.2a1.126 1.126 0 01-.976 1.22H2.062a1.126 1.126 0 01-.976-1.22V8.676h19.522V20.2zm0-15.672v3.064H1.086V4.528a.922.922 0 01.976-1h1.734v.6a1.116 1.116 0 001.166 1.03h1.6a1 1 0 001.03-.975v-.655h6.504v.6a1 1 0 00.975 1.03h1.655a1.116 1.116 0 001.17-1.037v-.6h1.735a.922.922 0 01.976 1z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgEvents;
